import { Bounds } from '@upright/ui/common/upright/core/impact-lens-profile/common/layout/types';

interface Props {
  /** Tail geometry from `impactGhostTailArea` / `dimensionGhostTailArea`. */
  bounds: Bounds;
  /** Stripe color — same fill as the solid bar the tail extends. */
  fill: string;
  /** Unique-per-svg pattern id; collisions would cross-paint sibling tails. */
  patternId: string;
}

/**
 * Faded, diagonally striped "ghost" tail appended after a bar to show a
 * pre-filter baseline (see `NetImpactLensData.ghostScores`): solid bar +
 * tail = baseline score. Faded on purpose — the tail is context, not a
 * score, so it should read as a shadow of the solid bar, not compete with
 * it. Visual match for the multi-series chart's stacked-bar ghost tail.
 */
export function LensGhostTail(props: Props) {
  const { bounds, fill, patternId } = props;
  return (
    <g>
      <defs>
        <pattern id={patternId} patternUnits="userSpaceOnUse" width={6} height={6} patternTransform="rotate(45)">
          <rect width={3} height={6} fill={fill} />
        </pattern>
      </defs>
      <rect
        x={bounds.x1}
        y={bounds.y1}
        width={bounds.width}
        height={bounds.height}
        fill={`url(#${patternId})`}
        opacity={0.45}
        rx={2}
        ry={2}
      />
    </g>
  );
}
